import React, { useEffect, useState } from "react";
import ListLayout from "../../../../../partials/content/ListLayout";
import ContentLayout from "../../../../../partials/content/ContentLayout";
import LeadBasicInfo from "./leadBasicInfo";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import LeadForm from "../leadForm";
import ConvertToCustomerForm from "../convertToCustomerForm";
import Notes from "../../../common/notes";
import Attachments from "../../../common/attachments";
import { getLead } from "../../../../../services/crm/leadService";
import LeadVisits from "./leadVisits";
import LeadSalesCards from "./leadSalesCards";
import LeadQuotations from "./leadQuotations";
import { PageSubHeader } from "../../../../../../provider/PageDataProvider";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";

function LeadDetail({ history, match, leadID = 0 }) {
  const { reload } = useGlobalData();
  const [component, setComponent] = useState(null);
  const [headerTitle, setHeaderTitle] = useState("");
  const [open, setOpen] = useState(false);
  const [openConvertCustomer, setOpenConvertCustomer] = useState(false);
  const [auth, setAuth] = useState(null);
  const [lead, setLead] = useState({});
  const defaultSelected = "basicInfo";
  const listMenu = [
    {
      key: "basicInfo",
      label: "Basic Info",
      icon: "fas fa-th-large",
    },
    {
      key: "salesCards",
      label: "Sales Cards",
      icon: "fas fa-address-card",
    },
    {
      key: "visits",
      label: "Visits",
      icon: "fas fa-route",
    },
    {
      key: "quotations",
      label: "Quotations",
      icon: "fas fa-file-contract",
    },
    {
      key: "attachments",
      label: "Attachments",
      icon: "fas fa-paperclip",
    },
    {
      key: "notes",
      label: "Notes",
      icon: "fas fa-sticky-note",
    },
  ];
  if (leadID === 0) {
    leadID = match.params.leadID;
  }
  useEffect(() => {
    getLeadData();
  }, [leadID, reload]);

  async function getLeadData() {
    const response = await getLead(leadID);
    const { data, auth } = response.data;
    setComponent(<LeadBasicInfo lead={data.lead} />);
    setLead(data.lead);
    setAuth(auth);
  }
  const actionButtons = [
    {
      title: "",
      color: "label-brand",
      icon: "fas fa-backward",
      onClick: () => {
        history.push("/crm/leads");
      },
    },
  ];
  if (lead.customerID === 0) {
    actionButtons.push({
      title: "Convert To Customer",
      color: "success",
      icon: "fas fa-exchange-alt",
      onClick: () => {
        setOpenConvertCustomer(true);
      },
    });
  }
  if (lead.customerID === 0 && lead.edit) {
    actionButtons.push({
      title: "Edit Lead",
      color: "primary",
      icon: "fas fa-edit",
      onClick: () => {
        setOpen(true);
      },
    });
  }

  return (
    <React.Fragment>
      <PageSubHeader
        title={headerTitle ? headerTitle : "Basic Info"}
        breadcrumbs={[
          { page: "/menu", title: "Menu", active: false },
          {
            page: "/crm/leads",
            title: "Leads",
            active: false,
          },
          {
            page: "/crm/lead-detail/" + leadID,
            title: "Lead ID " + leadID + " " + lead.leadName,
            active: true,
          },
        ]}
        actionButtons={actionButtons}
      />
      <ContentLayout>
        <ListLayout
          component={component}
          listMenu={listMenu}
          onSelectItem={(key) => {
            handleSelectItem(key);
          }}
          defaultSelected={defaultSelected}
        />
      </ContentLayout>
      <DialogLayout
        open={open}
        title="Lead Form"
        onCloseDialog={() => {
          setOpen(false);
        }}
        maxWIdth="md"
      >
        <LeadForm
          lead={lead}
          onCloseDialog={() => {
            setOpen(false);
          }}
          onConfirmSave={() => {
            getLeadData();
            setOpen(false);
            setOpenConvertCustomer(false);
          }}
        />
      </DialogLayout>
      <DialogLayout
        open={openConvertCustomer}
        title="Convert To Customer Form"
        onCloseDialog={() => {
          setOpenConvertCustomer(false);
        }}
        maxWIdth="md"
      >
        <ConvertToCustomerForm
          history={history}
          lead={lead}
          onCloseDialog={() => {
            setOpenConvertCustomer(false);
          }}
          onReloadLeads={() => {
            getLeadData();
            setOpen(false);
            setOpenConvertCustomer(false);
          }}
          onConfirmSave={() => {
            setOpenConvertCustomer(false);
          }}
        />
      </DialogLayout>
    </React.Fragment>
  );

  function handleSelectItem(key) {
    let componentTmp;
    let headerTitleTmp;
    switch (key) {
      case "basicInfo":
        componentTmp = <LeadBasicInfo lead={lead} />;
        headerTitleTmp = "Basic Info";
        break;
      case "salesCards":
        componentTmp = <LeadSalesCards leadID={lead.ID} history={history} />;
        headerTitleTmp = "Sales Cards";
        break;
      case "visits":
        componentTmp = <LeadVisits leadID={lead.ID} history={history} />;
        headerTitleTmp = "Visits";
        break;
      case "quotations":
        componentTmp = <LeadQuotations leadID={lead.ID} history={history} />;
        headerTitleTmp = "Quotations";
        break;
      case "attachments":
        componentTmp = <Attachments docType="LEAD" docID={lead.ID} />;
        headerTitleTmp = "Attachments";
        break;
      case "notes":
        componentTmp = <Notes docType="LEAD" docID={lead.ID} />;
        headerTitleTmp = "Notes";
        break;
      default:
        componentTmp = <LeadBasicInfo lead={lead} />;
        headerTitleTmp = "Basic Info";
        break;
    }
    setHeaderTitle(headerTitleTmp);
    setComponent(componentTmp);
  }
}

export default LeadDetail;
